export default __webpack_public_path__ + "static/media/bg09.baf0c263.svg";